import _regenerator from "/var/lib/jenkins/workspace/event-xsj-260120-vue/node_modules/.pnpm/@babel+runtime@7.28.4/node_modules/@babel/runtime/helpers/esm/regenerator.js";
import _asyncToGenerator from "/var/lib/jenkins/workspace/event-xsj-260120-vue/node_modules/.pnpm/@babel+runtime@7.28.4/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import "/var/lib/jenkins/workspace/event-xsj-260120-vue/node_modules/.pnpm/core-js@3.47.0/node_modules/core-js/modules/es.array.iterator.js";
import "/var/lib/jenkins/workspace/event-xsj-260120-vue/node_modules/.pnpm/core-js@3.47.0/node_modules/core-js/modules/es.promise.js";
import "/var/lib/jenkins/workspace/event-xsj-260120-vue/node_modules/.pnpm/core-js@3.47.0/node_modules/core-js/modules/es.object.assign.js";
import "/var/lib/jenkins/workspace/event-xsj-260120-vue/node_modules/.pnpm/core-js@3.47.0/node_modules/core-js/modules/es.promise.finally.js";
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.iterator.js";
import Vue from "vue";
import App from "./App.vue";
import MobileApp from "./mobile-app.vue";
import { createPinia, PiniaVuePlugin } from "pinia";
import { createHead } from "@unhead/vue";
import { gsap } from "gsap";
import { Observer } from "gsap/Observer";
import { ScrollToPlugin } from "gsap/ScrollToPlugin";
import { ScrollTrigger } from "gsap/ScrollTrigger";
import { initLang, preloadFonts } from "@/lib/utils";
import VConsole from "vconsole";
import "vant/lib/index.css";
import "./style.scss";
import { qs } from "./lib/utils";
import { isMobileDevice } from "@/components/basic/share/utils";
// import vClickOutside from 'v-click-outside';
// 只在开发环境启用，生产环境自动忽略
export var QS = qs();
if (process.env.NODE_ENV !== "production" || QS.console) {
  new VConsole();
}
// 1. 关闭生产环境提示（保持不变）
Vue.config.productionTip = false;
if (process.env.NODE_ENV === "development") {
  Vue.config.devtools = true;
}
var head = createHead();
// Vue.use(vClickOutside);
Vue.use(head);
// Vue.use(Overlay);
// Vue.use(CountDown);
// Vue.use(Popover);
var pinia = createPinia();
Vue.use(PiniaVuePlugin);
gsap.registerPlugin(Observer, ScrollTrigger, ScrollToPlugin);
function initApp() {
  return _initApp.apply(this, arguments);
} // 3. 执行异步初始化函数
function _initApp() {
  _initApp = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee() {
    var fontLang, _t, _t2, _t3, _t4, _t5, _t6, _t7, _t8, _t9;
    return _regenerator().w(function (_context) {
      while (1) switch (_context.p = _context.n) {
        case 0:
          _context.p = 0;
          _context.n = 1;
          return initLang();
        case 1:
          fontLang = Vue.prototype.$lang;
          if (!(fontLang === "ko-kr")) {
            _context.n = 3;
            break;
          }
          _t = preloadFonts;
          _t2 = "url(\"";
          _context.n = 2;
          return import("@/resources/raw-fonts/".concat(fontLang, "/HangamePoker.ttf"));
        case 2:
          _t3 = _t2.concat.call(_t2, _context.v.default, "\") format(\"truetype\")");
          _t4 = {
            family: "main-font",
            src: _t3
          };
          _t([_t4]);
          _context.n = 5;
          break;
        case 3:
          _t5 = preloadFonts;
          _t6 = "url(\"";
          _context.n = 4;
          return import("@/resources/raw-fonts/".concat(fontLang, "/SourceHanSerif.otf"));
        case 4:
          _t7 = _t6.concat.call(_t6, _context.v.default, "\") format(\"opentype\")");
          _t8 = {
            family: "main-font",
            src: _t7
          };
          _t5([_t8]);
        case 5:
          // if (fontLang === 'en-us' || fontLang === 'ko-kr') {
          //   preloadFonts([
          //     {
          //       family: "kr-content-2",
          //       src: `url("${
          //         (await import(`@/resources/raw-fonts/${fontLang}/content_2.otf`)).default
          //       }") format("opentype")`,
          //     },
          //     {
          //       family: "kr-content",
          //       src: `url("${
          //         (await import(`@/resources/raw-fonts/${fontLang}/content.otf`)).default
          //       }") format("opentype")`,
          //     },
          //   ]);
          // } else if (fontLang === 'zh-tw') {
          //   preloadFonts([
          //     {
          //       family: "kr-content-2",
          //       src: `url("${
          //         (await import(`@/resources/fonts/${fontLang}/content_2.woff2`)).default
          //       }") format("woff2")`,
          //     },
          //     {
          //       family: "kr-content",
          //       src: `url("${
          //         (await import(`@/resources/raw-fonts/${fontLang}/content.otf`)).default
          //       }") format("opentype")`,
          //     },
          //   ]);
          // } else {
          //   preloadFonts([
          //     {
          //       family: "kr-content-2",
          //       src: `url("${
          //         (await import(`@/resources/fonts/${fontLang}/content_2.woff2`)).default
          //       }") format("woff2")`,
          //     },
          //     {
          //       family: "kr-content",
          //       src: `url("${
          //         (await import(`@/resources/fonts/${fontLang}/content.woff2`)).default
          //       }") format("woff2")`,
          //     },
          //   ]);
          // }
          new Vue({
            pinia: pinia,
            render: function render(h) {
              return h(isMobileDevice() ? MobileApp : App);
            }
          }).$mount("#app");
          _context.n = 7;
          break;
        case 6:
          _context.p = 6;
          _t9 = _context.v;
          new Vue({
            pinia: pinia,
            render: function render(h) {
              return h(isMobileDevice() ? MobileApp : App);
            }
          }).$mount("#app");
        case 7:
          return _context.a(2);
      }
    }, _callee, null, [[0, 6]]);
  }));
  return _initApp.apply(this, arguments);
}
initApp();